import { render, staticRenderFns } from "./Monte.vue?vue&type=template&id=48a6198a&"
import script from "./Monte.vue?vue&type=script&lang=js&"
export * from "./Monte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports